import React ,{ useState }from "react";

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';
import { Table } from "react-bootstrap";
import Drawer from '@material-ui/core/Drawer';

import { createRequirement, getProducts, getMenus,getJobRequests,getJobServiceTypes,getJobNotes,completeTask,getScreenFields,updateNoti,getSettings,getMaster,getJobStatus,getPatientRights,getAccounts ,getDpExport} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';
import { Tooltip } from "@material-ui/core";	
//import InfiniteScroll from "react-infinite-scroller";
import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';					
import EditIcon from '@material-ui/icons/Edit';		
import Checkbox from '@material-ui/core/Checkbox';
//import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';	
import Chip from '@material-ui/core/Chip';

import Button from '@material-ui/core/Button';
//import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
 import CodeExample from "../../partials/content/CodeExample";
//import setDisplay from "../../partials/content/CodeExample";
import EditJobrStatus from './EditJobrStatus'

 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
//import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
 
import Autocomplete from '@material-ui/lab/Autocomplete';
//import { ThreeDRotationSharp, TrendingUpOutlined } from "@material-ui/icons";
import InvoiceAttributes from "../../widgets/InvoiceAttributes";
import Invoice from "../../widgets/Invoice";
//import { update } from "lodash";
import {
  Portlet,
  PortletBody,
  PortletHeader,
  PortletHeaderToolbar
} from "../../partials/content/Portlet";
import Alert from '@material-ui/lab/Alert'
import { toAbsoluteUrl } from "../../../_metronic/utils/utils";

import CircularProgress from '@material-ui/core/CircularProgress';
import CloseIcon from '@material-ui/icons/Close';
//import Moment from 'moment';
 

export default function Products({onUpdate,onClose,schedule}) {

	const [permission,setPermission] = useState({});
	const [postObj,setPostObj] = useState({});
	const [cart,setCart] = useState([]);
	const [totalAmount,setTotalAmount] = useState(0);
	const [totalQuantity,setTotalQuantity] = useState(0);
	const [products,setProducts] = useState([]);
	const [cartDrawerViewOpen,setCartDrawerViewOpen] = useState(false);
	const [hasMoreItems,setHasMoreItems] = useState(false);
	const [productName,setProductName] = useState('');
	const [productCode,setProductCode] = useState('');
	const [isLoading,setIsLoading] = useState(false);
	const [loading,setLoading] = useState(false);
	const [totalCount,setTotalCount] = useState(0);
	const [isReset,setIsReset] = useState(false);
	const [page,setPage] = useState(1);
	const [status,setStatus] = useState({flag:false, statusColor:'',statusMessage:'',loading:false});
	const [categoryKey,setCategoryKey] = useState('');
	const [subCategoryKey,setSubCategoryKey] = useState('');
	const [categories,setCategories] = useState([]);
	const [subCategories,setSubCategories] = useState([]);
	const [screenWidth, setScreenWidth] = useState(window.innerWidth);
	const [productLoading,setProductLoading] = useState(false);
 

 

 

const toggleCartDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    this.setState({cartDrawerViewOpen:false})
  };


const requestQuantity = () =>
{

	//console.log("request quantity");

	setStatus({flag:true, statusColor:'green',statusMessage:'Processing your request',loading:true});
	let createParams = {};
	let orders = [];
	cart.map((ct)=>{
		console.log(ct);
		orders.push({[ct.productKey]:ct.quantity});
	})
	createParams.scheduleId = schedule.scheduleId;
	if(schedule.schProcedureAccountKey!==null && schedule.schProcedureAccountKey.length>0)
		createParams.implantTypeKey = schedule.schProcedureAccountKey[0]
	createParams.products = orders;
	console.log(createParams);
	createRequirement(createParams);
	setStatus({flag:true, statusColor:'green',statusMessage:'The request for Staged Inventory added successfully.',loading:false});


}

  const loadMore=()=>{

  	setIsLoading(true);
    
	let pg = parseInt(page)+1;
  	
  	
     getProducts(pg,postObj,10)//.then(response => response.data)
  	.then((response) => 
    {
      setProducts(products.concat(response.data))
      setIsLoading(false);
	  setPage(pg);
      	if(parseInt(response.headers["x-total-records"])>products.length)
      		setHasMoreItems(true);
      	else
      		setHasMoreItems(false);

      });
   
   
  }

 



 React.useEffect(() => {
		  const fetch = async () => {
			  try {
			   setLoading(true);
			   setProductLoading(true);
 
			   getMenus().then(response => response.data)
		 	.then((data) => {
		   
		   		if(data[0] != null && data[0].permissions !=null)
					 {
					  
					   console.log(data[0].permissions);
					   let perms="";
					   data[0].permissions.map((per) =>(
						 perms = perms + "," + per
						 ))
					   console.log(perms);
						setPermission(perms);
	 
					 }
		  	});
		  	 let searchObj = {};
		  	 getProducts(1,searchObj,10)//.then(response => response.data)
			.then((response) => {

				let tempProducts = response.data;
				tempProducts.map((x)=>{
					x.quantity=0
				})
				
			setIsLoading(false);
			setProducts(tempProducts);
			setPostObj(searchObj);
			setPage(1);
			setProductLoading(false);
			setTotalCount(response.headers["x-total-records"]);
			if(parseInt(response.headers["x-total-records"])>response.data.length)
				setHasMoreItems(true)
			//isLoading:false})
			//console.log(this.state.users)
			})


			getMaster('category')//.then(response => response.data)
			.then((response) => {
				setCategories(response.data);
				
			})

			getMaster('subcategory')//.then(response => response.data)
			.then((response) => {
				setSubCategories(response.data);
				
			})


 
 
				 
  
			  } catch (e) {
				  console.log(e);
				  setLoading(false);
				  
			  }
		  };
		  fetch();
	  }, []);
  

 

 const handleFilter=(event)=>
 {

	console.log("handle filter");
	setIsLoading(true);
	setProductLoading(true);
	let searchObj={};
	  
	if(productName!==null && productName!==undefined && productName!=='')
	{
		searchObj['searchproductName'] = productName;
	}
	if(productCode!==null && productCode!==undefined && productCode!=='')
	{
		searchObj['searchproductCode'] = productCode;
	}
	if(categoryKey!==null && categoryKey!==undefined && categoryKey!=='')
	{
		searchObj['categoryKey'] = categoryKey;
	}
	if(subCategoryKey!==null && subCategoryKey!==undefined && subCategoryKey!=='')
	{
		searchObj['subCategoryKey'] = subCategoryKey;
	}

	console.log("postObj::::",searchObj);
	getProducts(1,searchObj,10)//.then(response => response.data)
    .then((response) => {
    	setIsLoading(false);
		setProductLoading(false);
      setProducts(response.data)
	  setPostObj(searchObj);
	  setPage(1);
      setTotalCount(response.headers["x-total-records"]);
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	setHasMoreItems(true)
	//,isLoading:false})
      //console.log(this.state.users)
     })


}


  //add to basket   
  const addBasket = (product) =>{
    console.log("add::::",product.productKey, product.productName,product.quantity);
    let newCart =  cart;

    let newProducts = products;

    //console.log("product:::::", newProducts);

    let productIndex = newProducts.findIndex(el => el.productKey == product.productKey);

	let fontColor = 'black';
	let bgColor = 'white';
	let stockStatus = null;
	if(newProducts[productIndex].currentStocks===0)
	{
		fontColor='white';
		bgColor = 'red';
		stockStatus = 'No Stock';
	}
	else if(newProducts[productIndex].currentStocks>0 && newProducts[productIndex].currentStocks<30)
	{
		fontColor='black';
		bgColor = 'yellow';
		stockStatus = 'Minimum Stock';
	}

	//console.log(fontColor)
    newProducts[productIndex] = {...newProducts[productIndex], quantity: parseInt(product.quantity) + 1,fontColor:fontColor,bgColor:bgColor,stockStatus:stockStatus};



    let cartIndex = newCart.findIndex(el => el.productKey == product.productKey);
    //console.log("cartIndex:::::",cartIndex);
    if(cartIndex < 0)
    {
      product.quantity = 1;
      product.totalPrice = product.price;
	  product.fontColor = fontColor;
	  product.bgColor = bgColor;
	  product.stockStatus = stockStatus;
      newCart.push(product);
    }
    else
    {
      newCart[cartIndex] = {...newCart[cartIndex], quantity: parseInt(newCart[cartIndex].quantity) + 1};
      newCart[cartIndex] = {...newCart[cartIndex], totalPrice: (parseInt(newCart[cartIndex].quantity)) *  parseFloat(product.price)};
    }

    
    
    //setTotalAmount(parseFloat(totalAmount)+(parseInt(product.quantity) +1) *  product.price);
    let sumTotal=0;
    let sumQuantity=0;
    newCart.map((p)=>{
      if(p.quantity>0)
      {
        sumTotal = parseFloat(sumTotal) + parseInt(p.quantity) * parseFloat(p.price);
        sumQuantity = parseInt(sumQuantity) + parseInt(p.quantity);

        //console.log("p::::",p,sumTotal);
      }
    })


    //this.setState({totalAmount:sumTotal,products: newProducts,totalQuantity:sumQuantity,cart:newCart });

   // console.log("sumtotal:::",sumTotal);
    setTotalAmount(sumTotal);
    setProducts(newProducts);
    setTotalQuantity(sumQuantity);
    setCart(newCart);

  }

 const addItem = (product) =>{
 console.log("add::::",product.productKey, product.productName,product.quantity);
  let newProducts =  cart;

  let index = newProducts.findIndex(el => el.productKey == product.productKey);
  newProducts[index] = {...newProducts[index], quantity: parseInt(product.quantity) + 1};
  newProducts[index] = {...newProducts[index], totalPrice: (parseInt(product.quantity) +1) *  parseFloat(product.price)};
  
  //setTotalAmount(parseFloat(totalAmount)+(parseInt(product.quantity) +1) *  product.price);
  let sumTotal=0;
  let sumQuantity=0;
  newProducts.map((p)=>{
    if(p.quantity>0)
    {
      sumTotal = parseFloat(sumTotal) + parseInt(p.quantity) * parseFloat(p.price);
      sumQuantity = parseInt(sumQuantity) + parseInt(p.quantity);
      //console.log("p::::",p,sumTotal);
    }
  })
 // console.log("sumtotal:::",sumTotal);
  setTotalAmount(sumTotal);
  setCart(newProducts);
  setTotalQuantity(sumQuantity);

   

  //products
  let tempProducts =  products;
  let tempindex = tempProducts.findIndex(el => el.productKey == product.productKey);
  tempProducts[tempindex] = {...tempProducts[tempindex], quantity: parseInt(product.quantity) + 1};
  setProducts(tempProducts);

  //this.setState({totalAmount:sumTotal,products: tempProducts,totalQuantity:sumQuantity,cart:newProducts});
  
  

}

const removeItem = (product) =>{
  console.log("remove::::",product);
  let newProducts =  cart;
  if(product.quantity>1)
  {
    let index = newProducts.findIndex(el => el.productKey == product.productKey);
    newProducts[index] = {...newProducts[index], quantity: parseInt(product.quantity) - 1};
    newProducts[index] = {...newProducts[index], totalPrice: (parseInt(product.quantity) -1) *  parseFloat(product.price)};
   
    //setTotalAmount(parseFloat(totalAmount)-(parseInt(product.quantity) -1) *  product.price);
    let sumTotal=0;
    let sumQuantity=0;
    newProducts.map((p)=>{
      sumTotal = parseFloat(sumTotal) + (parseInt(p.quantity) * parseFloat(p.price));
      sumQuantity = parseInt(sumQuantity) + parseInt(p.quantity);
    })
    //console.log("sumtotal::::",sumTotal);
    setTotalAmount(sumTotal);
    setCart(newProducts);
    setTotalQuantity(sumQuantity);


    //products
    let tempProducts =  products;
    let tempindex = tempProducts.findIndex(el => el.productKey == product.productKey);
    tempProducts[tempindex] = {...tempProducts[tempindex], quantity: parseInt(product.quantity) - 1};
    setProducts(tempProducts);
	//this.setState({totalAmount:sumTotal,products: tempProducts,totalQuantity:sumQuantity,cart:newProducts});

  }
  else
  {
    let index = newProducts.findIndex(el => el.productKey == product.productKey);
    //newProducts[index] = {...newProducts[index], quantity: parseInt(product.quantity) - 1};
    //newProducts[index] = {...newProducts[index], totalPrice: (parseInt(product.quantity) -1) *  product.price};
    newProducts.splice(index,1);
    //setTotalAmount(parseFloat(totalAmount)-(parseInt(product.quantity) -1) *  product.price);
    let sumTotal=0;
    let sumQuantity=0;
    newProducts.map((p)=>{
      sumTotal = parseFloat(sumTotal) + (parseInt(p.quantity) * parseFloat(p.price));
      sumQuantity = parseInt(sumQuantity) + parseInt(p.quantity);
    })
    //console.log("sumtotal::::",sumTotal);
    setTotalAmount(sumTotal);
    setCart(newProducts);
    setTotalQuantity(sumQuantity);

    //products
    let tempProducts = products;
    let tempindex = tempProducts.findIndex(el => el.productId == product.productId);
    tempProducts[tempindex] = {...tempProducts[tempindex], quantity: 0};
    setProducts(tempProducts);
	//this.setState({totalAmount:sumTotal,products: tempProducts,totalQuantity:sumQuantity,cart:newProducts});
  }

}


  const handleReset=(event)=>
  {
	setIsReset(false);
	setProductLoading(true);
	setProductName("")
	setProductCode("");
	setCategoryKey('');
	setSubCategoryKey('');
	let searchObj={};
	getProducts(1,searchObj,10)//.then(response => response.data)
    .then((response) => {
    	setIsLoading(false);
      setProducts(response.data)
	  setProductLoading(false);
	  setPostObj(searchObj);
	  setPage(1);
      setTotalCount(response.headers["x-total-records"]);
      if(parseInt(response.headers["x-total-records"])>response.data.length)
      	setHasMoreItems(true)

     })

			
  }


	  
	

    return (
     <div className="row" style={{ backgroundColor: '#EFEFF5',width:screenWidth}} >
		<div className="col-lg-8">

		
    		<div className="col-xl-12">
				<Portlet>
				  <PortletHeader
						  title={"Search Products"}
						  
						/>
						<PortletBody>
					<div className="kt-section" >
					  <Grid container spacing={3}>
					  
						<Grid item xs={12} sm={6}>
						  <TextField  style={{'width':'100%'}} 
						  	name="productName" 
							  id="productName"  
							  label="Product Name"
							   value={productName}
  							onChange={(event)=>setProductName(event.target.value)}
					      >
							
							 
						  </TextField>

						  
	
						</Grid>
						<Grid item xs={12} sm={6}>
						  <TextField  style={{'width':'100%'}} name="productCode" 
							  id="productCode"  label="Product Code"							  
							  value={productCode}
							  onChange={(event)=>setProductCode(event.target.value)}
					      >
							
							 
						  </TextField>

						</Grid>
						<Grid item xs={12} sm={6}>
						  <TextField fullWidth  style={{'width':'100%'}} name={'category'}
							select
							label={"Category"}
							value={categoryKey}
							onChange={event => setCategoryKey(event.target.value)}
							>
							{
								categories.map((row,index) => {
								return(
																	
									<MenuItem key={index} 
										value={row.categoryKey}>{row.categoryName}</MenuItem>
									)
								})
															
							}
						</TextField>
						

						</Grid>
						<Grid item xs={12} sm={6}>
						  <TextField fullWidth  style={{'width':'100%'}} name={'category'}
							select
							label={"Product"}
							value={subCategoryKey}
							onChange={event => setSubCategoryKey(event.target.value)}
							>
							{
								subCategories.map((row,index) => {
								return(
																	
									<MenuItem key={index} 
										value={row.subCategoryKey}>{row.subCategoryName}</MenuItem>
									)
								})
															
							}
						</TextField>
						

						</Grid>
						
					  </Grid>
					</div>
				
				<div>
				<Button
			  variant="outlined"
			  color="primary"
			  onClick={()=>handleFilter()}
			  endIcon={<Icon>search</Icon>}
			  style={{'padding':'10px','margin':'10px'}}
			  >
			  {
				isLoading==true&&<><Bounce /></>
			  }
			  {
				isLoading==false&&<>Apply Filter</>
			  }
			  </Button>
			  
			  <Button
			  variant="outlined"
			  color="primary"
			  onClick={()=>handleReset()}
			  endIcon={<Icon>backspace</Icon>}
			  style={{'padding':'10px','margin':'10px'}}
			  >
			  {
				isReset==true&&<><Bounce /></>
			  }
			  {
				isReset==false&&<>Reset Filter</>
			  }
			  </Button>
			  </div>
						</PortletBody>
				</Portlet>
			</div>
		    
			{/*<div className="col-xl-12">
				<Portlet>
					<PortletHeader
						  title={"Product Catalogue"}
						/>
				</Portlet>
			</div>*/}
			<div className="col-xl-12">
			  		{products!==null && products.length ===0 && !productLoading && 
					<div style={{alignItems: "center",display: 'flex', justifyContent: 'center', fontWeight:'bold'}}>                            
						<Alert severity="info">&nbsp;&nbsp;No Sizes found. Please choose category.</Alert>      
					</div>
					}
					 {productLoading &&
												<div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
													<Alert severity="info" icon={<CircularProgress size={15} />}>&nbsp;&nbsp;Loading please wait...</Alert>      
												</div>
										  }
										  <Portlet>
											<PortletBody>
										  <Table bordered style={{padding:0}}>
											<tr>
											<th>Product Code</th>
											<th>Product Name</th>
											<th>Action</th>
											
											</tr>
											<tbody>
											{products!==null && products.map((pp)=> (
 								
													<tr style={{fontSize:12,padding:0}} key={'aaa'+pp.id}>
														 
														  <td className="align-middle" style={{padding:0}}>{pp.productCode}</td>
														  <td className="align-middle" style={{padding:0}}>{pp.productName}</td>                  
														  <td className="align-middle" style={{padding:0}}><IconButton onClick={()=>addBasket(pp)}>
																						<AddShoppingCartIcon style={{ color: '#5578eb',fontSize: 18}}/>  
																				</IconButton></td>
														
														   
														</tr>
											))}
													
									
									</tbody>
													</Table>
													</PortletBody>
													</Portlet>	

					
			</div>
			<div className="col-xl-12">
				{/*</InfiniteScroll>*/}
				{
					hasMoreItems && products.length>0 &&
					<div style={{display:'flex', alignItems: 'center',
							justifyContent: 'center',
							flexDirection: 'column'}}>

						<Button
						variant="outlined"
						color="primary"
						onClick={()=>loadMore()}
						
						style={{'padding':'10px','margin':'10px'}}
						>
						{
							isLoading==true&&<><Bounce /></>
						}
						{
							isLoading==false&&<><SearchIcon style={{ color: '#5867dd',fontSize: 25}}/>  Load More</>
						}
						</Button>
				</div>
				}
			</div>
		</div>
		
		<div className="col-lg-4">
			<div className="kt-portlet kt-portlet--height-fluid">
			<div className="kt-portlet__head">
			<div className="kt-portlet__head-label">
				<h3 className="kt-portlet__head-title">{'CART'}</h3>
			</div>
			 <div className="kt-portlet__head-toolbar">
						<a href="#" onClick={onClose}><CloseIcon style={{ color: '#5867dd',fontSize: 25}} /> </a>
					  </div>
			</div>
			<div className="kt-portlet__body">
				
				{cart!==null && cart.length===0 && 
				 <div style={{alignItems: "center",display: 'flex', justifyContent: 'center', fontWeight:'bold'}}>                            
												{'Your cart is empty'}
											</div>
				}
			{cart!==null &&
			<div className="kt-widget4">
				<div className="kt-widget4__item" >
				</div>
				{ cart.map((item)=>(
				<div className="kt-widget4__item" >
				
				<div className="kt-widget4__info" style={{width:'50%'}}>
					
					<a
					className="kt-widget4__title"
					href="#"
					>
					{item.productName}
					</a>
					<p className="kt-widget4__text">{item.stockStatus!==null &&<Chip  size={'small'} label={item.stockStatus} style={{backgroundColor : item.bgColor,color:item.fontColor, fontWeight:'bold'}} />}</p>
				</div>
				<span className="kt-widget4__number kt-font-brand">
						<IconButton onClick={()=>addItem(item)}>
								<AddCircleOutlineIcon style={{ color: '#5578eb',fontSize: 18}}/>  
											</IconButton>
								{item.quantity}
											<IconButton onClick={()=>removeItem(item)}>
								<RemoveCircleOutlineIcon style={{ color: '#5578eb',fontSize: 18}}/>  
											</IconButton>
				</span>
				</div>
				

				))}
				<div className="kt-widget4__item" >
				{cart !== null && cart.length >0 && !status.flag && (
				<Button
					variant="outlined"
					color="primary"
					endIcon={<Icon>send</Icon>}
					onClick={requestQuantity}
					style={{'margin':'5px'}}
					>
					Update Stage Inventory
				</Button>
			)}
				{status.flag && (
					<div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
						<Alert icon={status.loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{status.statusMessage}</Alert>      
					</div>
						)}
				</div>
			
			</div>
			}
			
			</div>
			
			</div>

        </div>
    
      </div>
  );
}
